export default "__VITE_ASSET__D5ylty$R__"